import type { DocumentRepository } from "../repositories/document-repository"

export const makeRedoDocumentMetadata = (repo: DocumentRepository) =>
  (docId: string) =>
    repo.redoMetadata(docId)
